export default class InsufficientCreditsException extends Error {
    public currentBalance: number;

    constructor(currentBalance: number) {
        super("Insufficient credits to perform the operation.");
        this.currentBalance = currentBalance;
    }
}
